import Vue from 'vue'
import Vuex from 'vuex'
import pointsListStore from '@/store/pointsListStore'
import configStore from '@/store/configStore'
import snackbarStore from '@/store/snackbarStore'
import facilityStore from '@/store/facilityStore'
import userStore from '@/store/userStore'
import maintenanceRecordStore from '@/store/maintenanceRecordStore'
import urlStore from '@/store/urlStore'
import notificationStore from '@/store/notificationStore'
import whiteboardStore from '@/store/whiteboardStore'
import userPlotsStore from "./store/userPlotsStore";
import publishedCustomViewsStore from "./store/publishedCustomViewsStore";
import carnotEventStore from "./store/carnotEventStore";
import loginConfigStore from "./store/loginConfigStore";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    pointsListStore,
    configStore,
    snackbarStore,
    facilityStore,
    userStore,
    userPlotsStore,
    maintenanceRecordStore,
    urlStore,
    notificationStore,
    whiteboardStore,
    publishedCustomViewsStore,
    carnotEventStore,
    loginConfigStore
  },
  state: {

  },
  mutations: {

  },
  actions: {

  }
})
